import angular, { ICompileProvider, ILogProvider } from 'angular'

import { env } from '../../../lib/env'

/**
 * =======================================
 * Debug configuration
 * =======================================
 *
 * Configuration for setting up angular debug info and debug logging. Can be triggered by
 * `__WebRegisterTools.reloadWithDebugInfo()` via the web-register-tools module.
 */
angular.module('webregister').config(DebugConfig)

function DebugConfig(
  $compileProvider: ICompileProvider,
  $logProvider: ILogProvider,
  $windowProvider: $TSFixMe,
  wrDebugToolsProvider: $TSFixMe
) {
  const winNamePrefix = wrDebugToolsProvider.getEnableDebugLoggingPrefix()
  const WR_ENABLE_DEBUG_LOGGING = new RegExp(`^${winNamePrefix}`)
  const win = $windowProvider.$get()
  const enableDebug = env.isDevelopment()

  let enableDebugLogging = enableDebug

  if (win && WR_ENABLE_DEBUG_LOGGING.test(win.name)) {
    if (!enableDebug) {
      enableDebugLogging = true
    }

    win.name = win.name.replace(WR_ENABLE_DEBUG_LOGGING, '')
  }

  $compileProvider.debugInfoEnabled(enableDebug)
  $logProvider.debugEnabled(enableDebugLogging)
}
